export default __webpack_public_path__ + "static/media/advisory-icon.45b17e93.svg";